import React from 'react';

interface LogoProps {
  onClick: () => void;
  height?: number;
}

const Logo: React.FC<LogoProps> = ({ onClick, height = 82 }) => (
  <img
    src="/laundromatLogo.png"
    alt="Logo"
    style={{ height, cursor: 'pointer' }}
    onClick={onClick}
  />
);

export default Logo;
